module.exports = "https://img.xiyuyouxi.com/saas/img/shop_sale.e8d5b8f6.png";